import { formatter } from '@uhg-abyss/web/tools/formatter';

export const formatName = (...args) => {
  return args
    .filter((n) => n)
    .map((n) => formatter('capitalCase', n))
    .join(' ');
};
